import type { CuentaContable } from '@/views/pages/contabilidad/mantenimiento/EstadoPlanCuenta.vue'
import type { CuentaContableNIIF, CuentaContableSupCia } from '~typings/models/contabilidad/cuentas_contables'

import { createRequestBuilder } from '@core/utils/object'
import { defineStore } from '@core/utils/vuex'

type Paginated<T> = { data: T[]; page: number; per_page: number; total: number }
type Paginable<T> = T[] | Paginated<T>
function isPaginated<T>(value: Paginable<T>): value is Paginated<T> {
    const propNames = Object.getOwnPropertyNames(value)
    return typeof value === 'object' && propNames.includes('data') && propNames.includes('total')
}

export default defineStore({
    namespaced: true,
    state: {
        cuentaContable: null as Nullable<CuentaContable>,
        cuentasContables: null as Nullable<CuentaContable[]>,
        cuentasContablesPaginated: null as Nullable<Paginated<CuentaContable>>,
        cuentasNiff: null as Nullable<CuentaContableNIIF[]>,
        cuentasNiffPaginated: null as Nullable<Paginated<CuentaContableNIIF>>,
        cuentasSuperCias: null as Nullable<CuentaContableSupCia[]>,
        cuentasSuperCiasPaginated: null as Nullable<Paginated<CuentaContableSupCia>>,
    },
    getters: {
        getCuentasContables: state => state.cuentasContables,
        getCuentasNiif: state => state.cuentasNiff,
        getCuentasSuperCias: state => state.cuentasSuperCias,
    },
    mutations: {
        setCuentaContable(state, value: CuentaContable) {
            state.cuentaContable = value
        },
        setCuentaNiif(state, value: Paginable<CuentaContableNIIF>) {
            if (isPaginated(value)) {
                state.cuentasNiffPaginated = value
            } else {
                state.cuentasNiff = value
            }
        },
        setCuentaSuperCia(state, value: Paginable<CuentaContableSupCia>) {
            if (isPaginated(value)) {
                state.cuentasSuperCiasPaginated = value
            } else {
                state.cuentasSuperCias = value
            }
        },
    },
    actions: createRequestBuilder()
        .qGet('fetchCuentaContable', '/api/auth/contabilidad/cuentas-contables/:id_cuenta_contable')
        .qGet('fetchCuentasContables', '/api/auth/contabilidad/cuentas-contables')
        .qPut('updateCuentaContable', '/api/auth/contabilidad/cuentas-contables/:id_cuenta')
        .qPut('updatePoliticaCuenta', '/api/auth/contabilidad/cuentas-contables/:id_cuenta/politica')
        .qPost('crearCuentaContable', '/api/auth/contabilidad/cuentas-contables')
        .qPost('crearCuentaContableMasiva', '/api/auth/contabilidad/cuentas-contables/masiva')
        .addGet('fetchCuentasSuperCias', {
            route: '/api/auth/contabilidad/cuentas-contables/super-cias',
            action: 'setCuentaSuperCia',
        })
        .build(),
})
